import { Model, LoadingContainer } from 'peach/components'
import { useRouteMatch, Switch, Route, Redirect, useParams } from 'peach/router'

import { Page } from 'core/components'
import { isNotFoundError, R } from 'core/helpers'
import { useInternalGetLoanPeriods } from 'core/types'

import LoanPeriod from './LoanPeriod'

const LoanPeriods = () => {
  const { url, path } = useRouteMatch()

  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const {
    data: periods,
    isLoading,
    isError,
  } = useInternalGetLoanPeriods({
    companyId,
    personId,
    loanId,
    options: { throwOnError: R.isNot(isNotFoundError) },
  })

  return (
    <LoadingContainer error={isError} loading={isLoading}>
      <Switch>
        <Route crumb path={`${path}/:periodId`}>
          <LoanPeriod />
        </Route>

        <Route exact path={path}>
          <Page variant='full'>
            <Model.List json={periods} />
          </Page>
        </Route>

        <Redirect to={url} />
      </Switch>
    </LoadingContainer>
  )
}

export default LoanPeriods
